function requireRandomUuid() {
    const uuid = globalThis.crypto?.randomUUID?.();
    if (!uuid) {
        throw new Error("randomUUID is not available in this environment");
    }
    return uuid;
}
function createOpaqueId(prefix) {
    return `${prefix}_${requireRandomUuid()}`;
}
function getFilenameExtension(filename) {
    const trimmed = filename.trim();
    const match = /\.[a-z0-9]+$/i.exec(trimmed);
    return match?.[0].toLowerCase() ?? ".png";
}
export function createCollectionId() {
    return createOpaqueId("collection");
}
export function createTagId() {
    return createOpaqueId("tag");
}
export function createAssetId() {
    return createOpaqueId("asset");
}
export function createTaxonomyNodeId() {
    return createOpaqueId("taxonomy");
}
export function createOverlayTaxonomyNodeId() {
    return createOpaqueId("overlay-taxonomy");
}
export function createOverlayId() {
    return createOpaqueId("overlay");
}
export function createOverlayReferenceImageId() {
    return createOpaqueId("overlay-ref");
}
export function createOverlayPackId() {
    return createOpaqueId("overlay-pack");
}
export function createOverlayPackEntryId() {
    return createOpaqueId("overlay-pack-entry");
}
export function createTileId() {
    return createOpaqueId("tile");
}
export function createTileSetId() {
    return createOpaqueId("tile-set");
}
export function createCatalogAssetStoragePath(assetId, filename) {
    return `assets/tiles/${assetId}${getFilenameExtension(filename)}`;
}
export function createOverlayAssetStoragePath(...pathSegments) {
    const segments = pathSegments
        .map((segment) => segment.trim())
        .filter(Boolean);
    if (segments.length === 0) {
        throw new Error("Overlay storage path requires a filename");
    }
    return ["assets", "overlays", ...segments].join("/");
}
